module.exports = __webpack_public_path__ + "img/home-saude.e36bdccb.svg";